import { render } from "./PAddPhotosPrivate.vue?vue&type=template&id=573cd8ba"
import script from "./PAddPhotosPrivate.vue?vue&type=script&lang=js"
export * from "./PAddPhotosPrivate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__